import { Component } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DataAlert, DialogAlertComponent } from '../dialog-alert/dialog-alert.component';
import { DialogAlertService } from '../dialog-alert/dialog-alert.service';
import { AlertButtonType } from '../dialog-alert/AlertButtonType.enum';
import { AlertService } from '../alert/alert.service';
import { FormularioComponent } from '../formulario/formulario.component';
import { FormButtonType } from '../formulario/formButtonType.enum';
import { FORM_BUTTONS } from '../formulario/form-buttons.config';

@Component({
  selector: 'app-prueba-material',
  standalone: true,
  imports: [MatSlideToggleModule, DialogAlertComponent, FormularioComponent],
  templateUrl: './prueba-material.component.html',
  styleUrl: './prueba-material.component.scss'
})
export class PruebaMaterialComponent {
  
  constructor(
    private dialogService: DialogAlertService,
    private alertService: AlertService
  ) { }

  public openDialog() {
    let dataDialog: DataAlert = {
      title: 'Probando',
      content: '',
      buttonsAlert: [AlertButtonType.Aceptar, AlertButtonType.Cancelar]
    }
    let content = `  
      <ul>
        <li>
          @if (data.animal === 'panda') {
            <span>&#10003;</span>
          } Panda
        </li>
        <li>
          @if (data.animal === 'unicorn') {
            <span>&#10003;</span>
          } Unicorn
        </li>
        <li>
          @if (data.animal === 'lion') {
            <span>&#10003;</span>
          } Lion
        </li>
      </ul>`;
    dataDialog.content = content;
    const dialogRef = this.dialogService.openDialogAlert(dataDialog);
    dialogRef.afterClosed().subscribe(res => {
    })
  }

  openAlert () {
    this.alertService.success('Implementado con éxito!', 300000);
  }
}
